import join from 'lodash/join';

import {
  mapCountryRegionDtoToCountryRegionModel,
  mapFileMetadataDtoToFileMetadataModel,
  mapLanguageDtoToLanguageModel,
} from '../../shared/utils/mapping/mapping.utils';
import { AppDto } from '../dtos/app.dto';
import { CategoryDto } from '../dtos/category.dto';
import { AppTableModel } from '../models/app-table.model';
import { AppModel } from '../models/app.model';
import { CategoryModel } from '../models/category.model';
import { appPlatformsAdapter } from './app-platforms-adapter.util';
import { mapReleaseDtoToReleaseModel } from './releases-mapping.utils';

export function mapAppDtoToAppModel({
  categories,
  countriesRegions,
  defaultLanguage,
  icon,
  id,
  latestRelease,
  longDescription,
  name,
  privacyPolicy,
  publisherName,
  screenshots,
  shortDescription,
  website,
  packageName,
  isFeatured,
}: AppDto): AppModel {
  return {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    categories: categories.map(mapCategoryDtoToCategoryModel),
    countriesRegions: countriesRegions.map(
      mapCountryRegionDtoToCountryRegionModel
    ),
    defaultLanguage: mapLanguageDtoToLanguageModel(defaultLanguage),
    icon: mapFileMetadataDtoToFileMetadataModel(icon),
    id,
    latestRelease: mapReleaseDtoToReleaseModel(latestRelease),
    longDescription,
    name,
    privacyPolicy,
    publisherName,
    screenshots: screenshots.map(mapFileMetadataDtoToFileMetadataModel),
    shortDescription,
    website,
    packageName,
    isFeatured,
  };
}

export function mapCategoryDtoToCategoryModel({
  id,
  name,
}: CategoryDto): CategoryModel {
  return {
    id,
    name,
  };
}

export function mapAppDtoToAppTableModel({
  categories,
  icon,
  id,
  latestRelease,
  name,
}: AppDto): AppTableModel {
  return {
    categories: join(
      categories.map(category => category.name),
      ' & '
    ),
    icon: icon.downloadLink,
    id,
    lastUpdated: latestRelease?.updateDate,
    latestVersion: latestRelease?.versionName,
    name,
    platform: join(
      latestRelease?.platforms.map(
        platform => platform.name + ' ' + platform.version
      ),
      ', '
    ),
    status: latestRelease?.status,
    formattedPlatforms: appPlatformsAdapter(latestRelease?.platforms),
  };
}
